import React from "react";

const TermsOfService = () => {

    return (
        <div>
            <div className="row">
                <div className="offset-1 col-10 text-left my-5">
                    <span className="d-block mb-3">
                        Effective June 1, 2020
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">1. Account Registration</b>
                    <span className="d-block mb-3">
                        <b>1.1.</b> To become a User you must register and create a User Account on STB. You must provide a
                        valid email address, or a valid Google or Twitter account. It is a condition of your use of the Website
                        that all the information you provide on the Website is correct, current, and complete.
                    </span>
                    <span className="d-block mb-3">
                        <b>1.2.</b> You agree that all information you provide as a User or otherwise, including but not limited
                        to information provided through the use of any interactive features on the Website, is governed by STB’s
                        Privacy Policy, and you proceed on the basis that you are aware of how and why STB processes your data,
                        as is set out in STB’s Privacy Policy.
                    </span>
                    <span className="d-block mb-3">
                        <b>1.3.</b> If you wish to keep using STB after your free trial period, you will need to provide details
                        of a payment method to BrainTree, our payment processing provider. Your payment card information is
                        stored by the payment provider.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">2. By registering on STB, you confirm that</b>
                    <span className="d-block mb-3">
                        <b>2.1.</b> If you previously had a User Account with STB, your old User Account was not terminated or
                        suspended by STB for violation of the Terms of Service.
                    </span>
                    <span className="d-block mb-3">
                        <b>2.2.</b> You register on STB for your own personal use and you will not sell, rent or transfer your
                        User Account to any third party.
                    </span>
                    <span className="d-block mb-3">
                        <b>2.3.</b> STB reserve the right, at any time, to verify the information which you provide to STB as
                        well as your compliance with the Terms. If STB is unable to verify this then STB reserve the right to
                        suspend your account.
                    </span>
                    <span className="d-block mb-3">
                        <b>2.4</b> You will not use any third-party payment processors to accept payments for subscriptions, or
                        any other service, via STB.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">3. You are fully responsible for</b>
                    <span className="d-block mb-3">
                        <b>3.1.</b> Any and all activities that occur on your account and you are responsible for keeping your
                        login details confidential and secure. You agree not to disclose these details to any other person or
                        entity and immediately notify STB at <a href="mailto:support@securethebag.io">support@securethebag.io
                        </a> if you believe someone has used or is using your account without your permission or if your
                        account has been subject to any other breach of security. You also agree to ensure that you log out of
                        your account at the end of each session. You should use particular caution when accessing your account
                        from a public or shared computer so that others are not able to access, view or record your password or
                        other personal information.
                    </span>
                    <span className="d-block mb-3">
                        <b>3.2.</b> STB reserves the right to disable any user name, password, or other identifier, whether
                        chosen by you or provided by STB, at any time if, in STB’s opinion, you have violated any provision of
                        the Terms.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">4. Subscriptions, Purchases and Payment of Revenue</b>
                    <span className="d-block mb-3">
                        <b>4.1.</b> In order to use STB past your free trial, you must first add a payment method to your
                        account via your settings profile under “Subscribe”. Your payment card details will be passed to
                        BrainTree which will take payment from your selected payment method and process it toward your STB
                        account.
                    </span>
                    <span className="d-block mb-3">
                        <b>4.2.</b> Depending on your use of STB, BrainTree will take monthly payments or will take a 1-time
                        annual payment for a yearly subscription. You may cancel the monthly payments at any time by
                        contacting <a href="mailto:support@securethebag.io">support@securethebag.io</a>. You cannot cancel or
                        receive a refund for a purchased or gifted annual subscription – these subscriptions are non-refundable.
                        If you cancel your monthly subscription, you will lose access to your account unless a new subscription
                        is selected to continue use.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">5. Account Deletion</b>
                    <span className="d-block mb-3">
                        <b>5.1.</b> Should you wish to delete your STB membership you may do so by contacting <a href="mailto:support@securethebag.io">support@securethebag.io</a>.
                    </span>
                    <span className="d-block mb-3">
                        <b>5.2.</b> Any subscriptions per <b>5.1</b> will be deleted and cannot be subsequently renewed.
                    </span>
                    <span className="d-block mb-3">
                        <b>5.3.</b> You will receive an email confirmation upon the successful deletion of your account.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">6. Intellectual Property Rights</b>
                    <span className="d-block mb-3">
                        <b>6.1.</b> STB does not own User Content (e.g. income tracker entries and data). However, the Website
                        and its entire set of features and functionality (including but not limited to all information, software,
                        text, displays, images, video, and audio, and the design, selection, and arrangement thereof), are owned
                        by STB and are protected by international copyright, trademark, patent, trade secret, and other
                        intellectual property or proprietary rights laws.
                    </span>
                    <span className="d-block mb-3">
                        <b>6.2.</b> You must not reproduce, distribute, modify, create derivative works of, publicly display,
                        publicly perform, republish, download, store, or transmit any of the material on the Website, except
                        as follows:
                    </span>
                    <span className="d-block mb-3">
                        <b>6.2.1.</b> User Content: You may print, screenshot or download content from your account for your
                        own personal, non-commercial use and not for further reproduction, publication, or distribution.
                    </span>
                    <span className="d-block mb-3">
                        <b>6.3.</b> If you print, copy, modify, download, or otherwise use or provide any other person with
                        access to any part of the Website in breach of the Terms, your right to use the Website will end
                        immediately and you must, at STB’s option, return or destroy any copies of the materials you have made.
                    </span>
                    <span className="d-block mb-3">
                        <b>6.4.</b> Other than User Content, no right, title, or interest in or to the Website or any content
                        on the Website is transferred to you, and all rights not expressly granted are reserved by STB. Any use
                        of the Website not expressly permitted by these Terms is a breach of these Terms and may violate
                        copyright, trademark, and other laws.
                    </span>
                    <span className="d-block mb-3">
                        <b>6.5.</b> The STB name, logo and all related names, logos, product and service names, designs, and
                        slogans are trademarks of STB. You must not use such marks without STB’s prior written permission. All
                        other names, logos, product and service names, designs, and slogans on the Website are the trademarks
                        of their respective owners.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">7. License</b>
                    <span className="d-block mb-3">
                        <b>7.1.</b> Subject to all of the terms, conditions, limitations and restrictions contained in these
                        Terms, we grant to you a conditional, revocable, non-transferable, non-sublicensable, non-exclusive and
                        limited license to use the Website for your own lawful and personal use only. You acknowledge and agree
                        that the foregoing license may be revoked and terminated by STB at any time (including, without
                        limitation, if you violate these Terms). Any use of STB other than as expressly permitted by these
                        Terms is strictly prohibited. All rights not expressly granted herein are reserved by STB.
                    </span>
                    <span className="d-block mb-3">
                        <b>7.2.</b> STB does not warrant that STB is compatible with all devices and operating systems. It is
                        your sole responsibility to determine whether or not STB is compatible with your device.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">8. Acceptable Use</b>
                    <span className="d-block mb-3">
                        <b>8.1.</b> STB requires that all Users respect and comply with these Terms below, at all times, when
                        using STB.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.</b> You may not:
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.1.</b> Use STB other than for your own lawful and personal use in accordance with these Terms;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.2.</b> Impersonate STB or another User, or any other person or entity or falsely state, suggest
                        or otherwise misrepresent any affiliation, endorsement, sponsorship between you and STB and/or any other
                        person or entity;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.3.</b> Falsify account registration information, or make unauthorized use of another's information
                        or content;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.4.</b> Use STB in any manner or for any purpose that is illegal or unlawful, including engaging in
                        any activity that violates any right of any person or entity;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.5.</b> Copy, reproduce, distribute, modify, or create derivative works from, any portion of STB
                        without STB express written permission;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.6.</b> Use STB for the purpose of exploiting, harming, or attempting to exploit or harm minors in
                        any way by exposing them to inappropriate content, asking for personally identifiable information, or
                        otherwise;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.7.</b> Transmit, or procure the sending of, any advertising or promotional material, including any
                        “junk mail”, “chain letter”, “spam”, or any other similar solicitation;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.8.</b> Engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of the
                        Website, or which, as determined by STB, may harm STB or Users of the Website or expose them to liability;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.2.9.</b> Gives the impression that it emanates from or is endorsed by STB or any other person or
                        entity, if this is not the case.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.3.</b> You shall not remove, erase, modify or tamper with any copyright, trademark or other proprietary
                        rights notice that is contained in any User Content that you do not own.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.4.</b> You shall not use the Website in any manner that could disable, overburden, damage, or impair the
                        site or interfere with any other party’s use of the Website, including their ability to engage in real time
                        activities through the Website.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.5.</b> You shall not decompile, disassemble, reverse engineer, or otherwise attempt to discover or
                        derive the source code of STB.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.6.</b> You shall not interfere in any way with the operation of STB or any server, network or system
                        associated with STB, including, without limitation: hacking, mail-bombing, flooding, overloading, or making
                        "denial of service" attacks; probing, scanning or testing the vulnerability of the site or any server,
                        network or system associated with the site; breaching or circumventing firewall, encryption, security or
                        authentication routines; accessing information not intended for you, or accessing another user's account
                        that you are not expressly authorized to access.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.7.</b> You shall not use STB for any unauthorized purpose, including, without limitation, for purposes
                        of building a competitive product or service, performance or functionality, or for any other competitive
                        purposes;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.8.</b> You shall not use any automated program, tool or process (including without limitation, web
                        crawlers, robots, bots spiders, and automated scripts) to access STB or any server, network or system
                        associated with STB, or to extract, collect, harvest or gather content or information from STB.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.9.</b> You shall not make any other use of STB that violates these Terms.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.10.</b> Users who repeatedly violate STB’s Acceptable Use policy may be deactivated.
                    </span>
                    <span className="d-block mb-3">
                        <b>8.11.</b> By registering an account with STB, you represent and warrant that:
                    </span>
                    <span className="d-block mb-3">
                        <b>8.11.1.</b> You will fully comply with these Terms;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.11.2.</b> You accept full responsibility for the use of STB on any device, whether or not it is owned
                        by you;
                    </span>
                    <span className="d-block mb-3">
                        <b>8.11.3.</b> You accept full responsibility for any User Content created or provided by you; and
                    </span>
                    <span className="d-block mb-3">
                        <b>8.11.4.</b> Your use of STB will not violate these Terms.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">9. User Content</b>
                    <span className="d-block mb-3">
                        <b>9.1.</b> User Content by definition is any income entry made by you as a User on STB. You are the sole
                        owner of this information.
                    </span>
                    <span className="d-block mb-3">
                        <b>9.2.</b> Your User Content will never be used by STB or sold to third-party vendors. If you delete your
                        account by contacting <a href="mailto:support@securethebag.io">support@securethebag.io</a>, your user data
                        will be deleted as well. We encourage you to export your entry information prior to account deletion.
                    </span>
                    <span className="d-block mb-3">
                        <b>9.3.</b> You shall indemnify STB against all liabilities, costs, expenses, damages and losses
                        (including any direct, indirect or consequential losses, loss of profit, loss of reputation and all
                        interest, penalties and legal costs (calculated on a full indemnity basis) and all other reasonable
                        professional costs and expenses suffered or incurred arising out of or in connection with your User
                        Content.
                    </span>
                    <span className="d-block mb-3">
                        <b>9.4.</b> Any questions regarding User Content can be addressed by emailing <a href="mailto:support@securethebag.io">support@securethebag.io</a>.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">10. Referral Program</b>
                    <span className="d-block mb-3">
                        <b>10.1.</b> STB offers a referral program which incentivizes Users to introduce STB to people who are
                        interested in becoming Users. This clause sets out when STB will pay an Incentive Payment. STB reserves the
                        right to change the how it pays Incentive Payments but no change will deprive any Users of Incentive
                        Payments already earned before the changes came into effect:
                    </span>
                    <span className="d-block mb-3">
                        <b>10.1.1.</b> Users with a valid User Account with STB can participate;
                    </span>
                    <span className="d-block mb-3">
                        <b>10.1.2.</b> Each User Account has a unique referral URL which allows Users to earn Incentive Payments;
                    </span>
                    <span className="d-block mb-3">
                        <b>10.1.3.</b> The referred User must use the referring User’s URL and then register with STB using the
                        same browser that they used to click the referral link;
                    </span>
                    <span className="d-block mb-3">
                        <b>10.1.4.</b> The referred User has to be someone who has never held a User Account (defined by a unique
                        email address). If the referred User has been or is an existing User STB will not pay Incentive Payments
                        to the referring User;
                    </span>
                    <span className="d-block mb-3">
                        <b>10.1.5.</b> STB will not pay Incentive Payments if the referred User does not join STB using the
                        correct referral link;
                    </span>
                    <span className="d-block mb-3">
                        <b>10.1.6.</b> If the referred User then sets up more than one new User Account then the obligation to
                        pay Incentive Payments shall only apply to one new User Account. The referred User will only be a new
                        User with respect to the first User Account.
                    </span>
                    <span className="d-block mb-3">
                        <b>10.1.7.</b> Users may not use confusing business practices to impersonate STB with the intention to
                        refer other Users to receive Incentive Payments.
                    </span>
                    <span className="d-block mb-3">
                        <b>10.2.</b> If it transpires that Incentive Payments have been made incorrectly then STB reserves the
                        right to recover those monies from the referring User.
                    </span>
                    <span className="d-block mb-3">
                        <b>10.3.</b> In order to ensure that the referral program is not abused, STB reserves the right to
                        verify the credentials and identity of referred Users and referring Users claiming to have introduced
                        the referred Users.
                    </span>
                    <span className="d-block mb-3">
                        <b>10.4.</b> The Incentive Payment will be processed on the first calendar business day of each month
                        and paid in accordance with the Payment Provider’s terms.
                    </span>
                    <span className="d-block mb-3">
                        <b>10.5.</b> The Incentive Payment is deducted from the monies that STB would retain from the
                        transaction and not from the monies earned by the referred User.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">11. Disclaimer of Warranties; Limitations of Liability</b>
                    <span className="d-block mb-3">
                        <b>11.1.</b> By using STB, you acknowledge and agree as follows:
                    </span>
                    <span className="d-block mb-3">
                        <b>11.1.1.</b> STB and all of its services and features are provided without warranties of any kind,
                        express or implied. To the fullest extent permitted by law, STB disclaims any and all warranties,
                        express or implied, with respect to STB and all of its services and features, including, and without
                        limitation, implied warranties of merchantability and fitness for a particular purpose. STB does not
                        warrant or guarantee the accuracy, usefulness, completeness or reliability of STB, or the results of
                        your use of STB. STB disclaims all liability and responsibility arising from any reliance placed on
                        such materials by you or any other visitor to the Website, or by anyone who may be informed of any
                        of its contents. STB also does not warrant or guarantee that STB and all of its services and features
                        will be available at any particular time or location; that STB and all of its services and features
                        will be secure, uninterrupted, and error-free; that any defect or error will be corrected; or that
                        STB and all of its services and features will be free of viruses and other harmful components. You
                        are responsible for implementing sufficient procedures and checkpoints to satisfy your particular
                        requirements for antivirus protection and accuracy of data input and output, and for maintaining a
                        means external to the Website for any reconstruction of any lost data. To the fullest extent provided
                        by law, STB will not be liable for any loss or damage caused by a distributed denial-of-service attack,
                        viruses, or other technologically harmful material that may infect your computer equipment, computer
                        programs, data, or other proprietary material due to your use of the Website or any services or items
                        obtained through the Website or to your downloading of any material posted on it, or on any website
                        linked to it. Your use of STB and its services and features will be solely and entirely at your own
                        risk. The foregoing does not affect any warranties that cannot be excluded or limited under applicable
                        law;
                    </span>
                    <span className="d-block mb-3">
                        <b>11.1.2.</b> STB does not warrant or guarantee that use of the Website will be uninterrupted or error
                        free twenty-four hours a day, seven days a week, since STB may need to carry out maintenance of the
                        Website from time to time. However, STB will use its reasonable accommodations to carry out any such
                        maintenance of the Website outside of business hours and STB will accommodate to give reasonable notice,
                        however this may not always be possible;
                    </span>
                    <span className="d-block mb-3">
                        <b>11.1.3.</b> In no event shall STB be liable (strictly or otherwise) in contract, tort, negligence,
                        strict liability or under any other legal or equitable principle, for any indirect, incidental,
                        exemplary, special, punitive or consequential damages (including, and without limitation, loss of use,
                        profits, data or information, or loss of business goodwill or opportunity) arising out of or related
                        to your use of (or your inability to use) STB or any of its services or features
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">12. User indemnification</b>
                    <span className="d-block mb-3">
                        <b>12.1.</b> By using STB, you agree to indemnify and hold harmless STB and our employees from and
                        against any and all claims, demands, causes of action, actions, suits, proceedings, judgments, orders,
                        damages, liabilities, losses, costs and expenses (including, without limitation, reasonable attorneys'
                        fees and legal costs) arising out of or related to any of the following:
                    </span>
                    <span className="d-block mb-3">
                        <b>12.1.1.</b> Your use of STB or any of its services or features;
                    </span>
                    <span className="d-block mb-3">
                        <b>12.1.2.</b> Any User Content created, published, or otherwise made available on STB by you;
                    </span>
                    <span className="d-block mb-3">
                        <b>12.1.3.</b> Your violation of the Terms.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">13. Governing Law and Dispute Resolution</b>
                    <span className="d-block mb-3">
                        <b>13.1.</b> You and STB agree that these Terms shall be governed by and construed in accordance with
                        the laws of the United States of America.
                    </span>
                    <span className="d-block mb-3">
                        <b>13.2.</b> Except where prohibited by applicable law, any claim or cause of action by you concerning
                        STB or arising out of or related to these Terms must be filed within one year after such claim or cause
                        of action arose, or be forever barred.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">14. Waiver and Severability</b>
                    <span className="d-block mb-3">
                        <b>14.1.</b> No waiver of any term or condition set out in these Terms shall be deemed a further or
                        continuing waiver of such term or condition or a waiver of any other term or condition, and any failure
                        to assert a right or provision under these Terms shall not constitute a waiver of such right or
                        provision.
                    </span>
                    <span className="d-block mb-3">
                        <b>14.2.</b> If any provision of these Terms is held by a court or other tribunal of competent
                        jurisdiction to be invalid, illegal or unenforceable for any reason, such provision shall be eliminated
                        or limited to the minimum extent such that the remaining provisions of the Terms will continue in full
                        force and effect.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">15. General</b>
                    <span className="d-block mb-3">
                        <b>15.1.</b> The Terms constitute the sole and entire agreement between you and STB regarding the
                        Website and supersede all prior and contemporaneous understandings, agreements, representations,
                        and warranties, both written and oral, regarding the Website.
                    </span>

                    <b className="font-22 d-block mt-5 mb-3">16. Contact</b>
                    <span className="d-block mb-3">
                        <b>16.1.</b> If you have any questions, comments, complaints or concerns about STB, please contact
                        our support team at <a href="mailto:support@securethebag.io">support@securethebag.io</a>.
                    </span>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
